"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _environment = require("../constants/environment");

var _filters = require("../constants/filters");

var _snackbarStatus = require("../constants/snackbarStatus");

var _apis = require("../services/apis");

var _helpers = require("../services/helpers");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useSavedSearch = function useSavedSearch(_ref) {
  var fulfillerId = _ref.fulfillerId,
      fulfillerName = _ref.fulfillerName,
      externalFilters = _ref.externalFilters,
      filterPrecedence = _ref.filterPrecedence,
      showSnackbar = _ref.showSnackbar,
      accessToken = _ref.accessToken,
      _ref$environment = _ref.environment,
      environment = _ref$environment === void 0 ? _environment.ENVIRONMENT.PRODUCTION : _ref$environment;

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = (0, _react.useState)({}),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      defaultFilters = _useState4[0],
      setDefaultFilters = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      userSavedSearches = _useState6[0],
      setUserSavedSearches = _useState6[1];

  var _useState7 = (0, _react.useState)({}),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      sharedFilterValues = _useState8[0],
      setSharedFilterValues = _useState8[1];

  var _useState9 = (0, _react.useState)(),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      savedSearchToApply = _useState10[0],
      setSavedSearchToApply = _useState10[1];

  var _useState11 = (0, _react.useState)(function () {
    var _externalFilters$FILT, _externalFilters$FILT2;

    return externalFilters && (((_externalFilters$FILT = externalFilters[_filters.FILTER_NAMES.FULFILLER]) === null || _externalFilters$FILT === void 0 ? void 0 : _externalFilters$FILT.length) || ((_externalFilters$FILT2 = externalFilters[_filters.FILTER_NAMES.MERCHANT]) === null || _externalFilters$FILT2 === void 0 ? void 0 : _externalFilters$FILT2.length));
  }),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 1),
      filtersPassed = _useState12[0];

  (0, _react.useEffect)(function () {
    var getBasicFilters = function getBasicFilters() {
      var _defaultFilters;

      var referenceDate = (0, _helpers.getReferenceDate)();
      var defaultFilters = (_defaultFilters = {}, (0, _defineProperty2["default"])(_defaultFilters, _filters.TIME_FRAME.name, _filters.TIME_FRAME.options[0]), (0, _defineProperty2["default"])(_defaultFilters, _filters.CURRENCY.name, _filters.CURRENCY.options[0]), (0, _defineProperty2["default"])(_defaultFilters, _filters.REFERENCE_DATE.name, {
        label: referenceDate,
        value: referenceDate
      }), _defaultFilters);

      if (fulfillerId) {
        defaultFilters[_filters.FULFILLER.name] = [{
          label: fulfillerName,
          value: fulfillerName
        }];
      } else if (externalFilters) {
        var _externalFilters$FILT3, _externalFilters$FILT4;

        if ((_externalFilters$FILT3 = externalFilters[_filters.FILTER_NAMES.FULFILLER]) !== null && _externalFilters$FILT3 !== void 0 && _externalFilters$FILT3.length) {
          defaultFilters[_filters.FULFILLER.name] = externalFilters[_filters.FILTER_NAMES.FULFILLER].map(function (_ref2) {
            var name = _ref2.name,
                fulfillerId = _ref2.fulfillerId;
            return {
              label: name,
              value: name,
              id: fulfillerId
            };
          });
        }

        if ((_externalFilters$FILT4 = externalFilters[_filters.FILTER_NAMES.MERCHANT]) !== null && _externalFilters$FILT4 !== void 0 && _externalFilters$FILT4.length) {
          defaultFilters[_filters.MERCHANT.name] = externalFilters[_filters.FILTER_NAMES.MERCHANT].map(function (_ref3) {
            var merchantId = _ref3.merchantId,
                displayName = _ref3.displayName;
            return {
              label: displayName,
              value: merchantId,
              id: merchantId
            };
          });
        }
      }

      return defaultFilters;
    };

    var getUserSavedSearches = /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var defaultSavedSearch, lastSearchedFilters, basicFilters, _yield$getUserSetting, savedSearches, sharedFilters, _lastSearchedFilters, prioritizedSavedSearch, _ref5, currency, timeFrame, currentFilters, _error$response;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                basicFilters = getBasicFilters();
                _context.prev = 1;
                _context.next = 4;
                return (0, _apis.getUserSettings)({
                  environment: environment,
                  accessToken: accessToken
                }, {
                  key: fulfillerId
                });

              case 4:
                _yield$getUserSetting = _context.sent;
                savedSearches = _yield$getUserSetting.userSavedSearches;
                sharedFilters = _yield$getUserSetting.sharedFilterValues;
                savedSearches === null || savedSearches === void 0 ? void 0 : savedSearches.forEach(function (search) {
                  if (search.isDefault) defaultSavedSearch = search;
                  if (search.isLast) lastSearchedFilters = search;
                });

                if (lastSearchedFilters) {
                  lastSearchedFilters.value = _objectSpread(_objectSpread({}, (_lastSearchedFilters = lastSearchedFilters) === null || _lastSearchedFilters === void 0 ? void 0 : _lastSearchedFilters.value), sharedFilters.value);
                } // when user navigates to any view for the first time, lastSearched filters will be created using SHARED_FILTERS
                else if (Object.keys(sharedFilters).length) {
                  lastSearchedFilters = sharedFilters;
                  savedSearches.push(sharedFilters);
                } // assigning priority based on filterPrecedence


                prioritizedSavedSearch = filterPrecedence === _filters.FILTER_PRECEDENCE.LAST ? lastSearchedFilters || defaultSavedSearch : defaultSavedSearch || lastSearchedFilters;
                _ref5 = (prioritizedSavedSearch === null || prioritizedSavedSearch === void 0 ? void 0 : prioritizedSavedSearch.value) || {}, currency = _ref5[_filters.CURRENCY.name], timeFrame = _ref5[_filters.TIME_FRAME.name];
                currentFilters = _objectSpread(_objectSpread({}, basicFilters), externalFilters ? _objectSpread(_objectSpread({}, currency && (0, _defineProperty2["default"])({}, _filters.CURRENCY.name, currency)), timeFrame && (0, _defineProperty2["default"])({}, _filters.TIME_FRAME.name, timeFrame)) : prioritizedSavedSearch === null || prioritizedSavedSearch === void 0 ? void 0 : prioritizedSavedSearch.value);
                setDefaultFilters(currentFilters);
                setUserSavedSearches(savedSearches);
                setSharedFilterValues(sharedFilters);
                if (!filtersPassed) setSavedSearchToApply(prioritizedSavedSearch);
                _context.next = 23;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](1);
                console.error((_context.t0 === null || _context.t0 === void 0 ? void 0 : (_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.data) || (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.response) || _context.t0);
                showSnackbar({
                  status: _snackbarStatus.SNACKBAR_STATUS.DANGER,
                  message: 'Error while fetching saved searches. Please try reloading if you need them.'
                });
                setDefaultFilters(basicFilters);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 18]]);
      }));

      return function getUserSavedSearches() {
        return _ref4.apply(this, arguments);
      };
    }();

    var init = /*#__PURE__*/function () {
      var _ref8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                setIsLoading(true);
                _context2.next = 3;
                return getUserSavedSearches();

              case 3:
                setIsLoading(false);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function init() {
        return _ref8.apply(this, arguments);
      };
    }();

    init();
  }, [fulfillerId, fulfillerName, externalFilters, filterPrecedence, showSnackbar]);
  return {
    defaultFilters: defaultFilters,
    savedSearchToApply: savedSearchToApply,
    userSavedSearches: userSavedSearches,
    sharedFilterValues: sharedFilterValues,
    isLoading: isLoading
  };
};

var _default = useSavedSearch;
exports["default"] = _default;